export const PRODUCTION = 'prod'
export const DEVELOPMENT = 'dev'
export const QS = 'qs'
